import UserProfile from "../views/UserProfile.vue";

export const routes = [
  {
    path: "/profile",
    name: "Profile",
    meta: {},
    component: UserProfile,
  },
];
